import React from "react";
import "./styles/Project.css";
import Blackjack from "./BlackJack";
import { FaTimes } from "react-icons/fa";

export default class Project extends React.Component {
  constructor(props) {
    super(props);
    this.image = this.image.bind(this);
    this.display = this.display.bind(this);
    this.liveDemo = this.liveDemo.bind(this);
    this.state = {
      showProject: false,
      display: props.display,
      id: props.id,
      CurrentIMG: props.CurrentIMG,
      text: props.text,
      name: props.name,
    };
  }

  image = () => {
    if (this.state.CurrentIMG !== "none") {
      return (
        <img className="project-img" src={this.state.CurrentIMG} alt=""></img>
      );
    } else {
      return;
    }
  };

  display = () => {
    this.setState({ showProject: !this.state.showProject });
  };

  liveDemo = () => {
    if (this.state.id === "BJ")
      return (
        <button className="sample" onClick={this.display}>
          <p>Live Demo</p>
        </button>
      );
    if (this.state.id === "Fantasy")
      return (
        <button className="sample">
          <a
            className="visit"
            href="https://www.fantasyfootballformula.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Visit
          </a>
        </button>
      );
    return null;
  };

  render() {
    if (!this.state.showProject) {
      return (
        <div
          id={this.state.id}
          style={{ display: this.state.display }}
          className="app column"
        >
          <div className="project-text">
            {this.state.CurrentIMG.length && (
              <div className="img-scroller">{this.image(this.state)}</div>
            )}
            {this.liveDemo()}
            <h4 className="project-h2">{this.state.name}</h4>
            <p className="project-p">{this.state.text}</p>
          </div>
        </div>
      );
    } else {
      return (
        <div id="BJ" className="app column">
          <div className="closeOut">
            <FaTimes className="close" onClick={this.display} />
          </div>
          <Blackjack />
        </div>
      );
    }
  }
}
